import { jsxs as r, jsx as o } from "react/jsx-runtime";
import { useId as p } from "react";
import C from "clsx";
import { getStarsDefaultColor as f } from "./utils.js";
import '../../../_assets/SvgStar.DW1JR84n.css';const x = "_starIcon_1h7jx_44", a = {
  starIcon: x,
  "slide-in-out": "_slide-in-out_1h7jx_1",
  "fade-in-out": "_fade-in-out_1h7jx_1"
}, u = ({ item: l, rating: c, className: n, theme: d, thin: L }) => {
  const s = p(), e = c ?? 0;
  let t;
  e > l ? t = "100%" : l - e > 1 ? t = "0%" : t = `${Math.abs(l - 1 - e) * 100}%`;
  const i = f(d);
  return L ? /* @__PURE__ */ r(
    "svg",
    {
      viewBox: "0 0 30 31",
      className: C(a.starIcon, n),
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ o("defs", { children: /* @__PURE__ */ r("linearGradient", { id: s, x1: "0", x2: "100%", y1: "0", y2: "0", children: [
          /* @__PURE__ */ o("stop", { offset: t, stopColor: i }),
          /* @__PURE__ */ o("stop", { offset: t, stopColor: "#E0E2E2" })
        ] }) }),
        /* @__PURE__ */ o(
          "path",
          {
            d: "M14.5245 1.59146C14.6741 1.1308 15.3259 1.1308 15.4755 1.59145L18.2555 10.1472C18.3224 10.3532 18.5144 10.4927 18.731 10.4927H27.727C28.2114 10.4927 28.4128 11.1125 28.0209 11.3972L20.743 16.6849C20.5677 16.8122 20.4944 17.0379 20.5613 17.2439L23.3413 25.7997C23.4909 26.2603 22.9637 26.6434 22.5718 26.3587L15.2939 21.0709C15.1186 20.9436 14.8814 20.9436 14.7061 21.0709L7.42817 26.3587C7.03631 26.6434 6.50907 26.2603 6.65875 25.7997L9.43867 17.2439C9.50561 17.0379 9.43228 16.8122 9.25704 16.6849L1.9791 11.3972C1.58725 11.1125 1.78863 10.4927 2.27299 10.4927H11.269C11.4856 10.4927 11.6776 10.3532 11.7445 10.1472L14.5245 1.59146Z",
            fill: `url(#${s})`
          }
        )
      ]
    }
  ) : /* @__PURE__ */ r(
    "svg",
    {
      viewBox: "0 0 41 40",
      className: C(a.starIcon, n),
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ o("defs", { children: /* @__PURE__ */ r("linearGradient", { id: s, x1: "0", x2: "100%", y1: "0", y2: "0", children: [
          /* @__PURE__ */ o("stop", { offset: t, stopColor: i }),
          /* @__PURE__ */ o("stop", { offset: t, stopColor: "#E0E2E2" })
        ] }) }),
        /* @__PURE__ */ o(
          "path",
          {
            d: "M19.6856 2.09048C20.0354 1.29223 21.1678 1.29223 21.5175 2.09048L25.8331 11.9401C25.9782 12.2712 26.2906 12.4982 26.6504 12.5339L37.3515 13.5945C38.2187 13.6805 38.5687 14.7575 37.9176 15.3368L29.8836 22.4848C29.6136 22.7251 29.4942 23.0925 29.5715 23.4456L31.8695 33.9507C32.0558 34.8021 31.1397 35.4677 30.3875 35.0275L21.1067 29.5956C20.7947 29.413 20.4084 29.413 20.0964 29.5956L10.8156 35.0275C10.0635 35.4677 9.14736 34.8021 9.3336 33.9507L11.6317 23.4456C11.7089 23.0925 11.5896 22.7251 11.3195 22.4848L3.28555 15.3368C2.63446 14.7575 2.98438 13.6805 3.85163 13.5945L14.5527 12.5339C14.9125 12.4982 15.225 12.2712 15.37 11.9401L19.6856 2.09048Z",
            fill: `url(#${s})`
          }
        )
      ]
    }
  );
};
export {
  u as SvgStar
};
